<template>
  <div class="registration-stepper">
    <div class="steps">
      <flow-step
        v-for="(name, index) in stepNames"
        :key="name"
        :stepNumber="index + 1"
        :stepName="$t(name)"
        :ready="visitedStepsCnt >= index + 1 && currentStep !== index + 1"
        :active="(currentStep === index + 1)"
        :disabled="disabledValue[index] || (currentStep !== index + 1 && currentStep === maxStep)"
        @clicked="onClickStepButton"
      />
    </div>
    <two-way-controls
      :forwardActive="allowNext"
      :backHidden="backHiddenDisabled"
      :forwardHidden="currentStep === maxStep"
      :forwardLoading="loadingNext"
      :backTitle="$t('newProject.previous')"
      :forwardTitle="$t('newProject.next')"
      @click:back="navigatePreviousStep"
      @click:forward="navigateNextStep"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import FlowStep from '@/components/common/FlowStep.vue';
import TwoWayControls from '@/components/common/TwoWayControls.vue';

export default {
  name: 'RegistrationStepper',
  components: {
    FlowStep,
    TwoWayControls,
  },
  props: {
    currentStep: {
      type: Number,
      required: true,
    },
    visitedStepsCnt: {
      type: Number,
      required: true,
    },
    allowNext: {
      type: Boolean,
      required: true,
    },
    loadingNext: {
      type: Boolean,
      default: false,
    },
    stepNames: {
      type: Array,
      required: true,
    },
    disabled: {
      type: Array,
      required: false,
    },
  },
  computed: {
    ...mapGetters([
      'isUserPoolExist',
    ]),
    maxStep() {
      return this.stepNames.length;
    },
    minStep() {
      return 1;
    },
    disabledValue() {
      return this.disabled ? this.disabled : (new Array(this.stepNames.length)).fill(false);
    },
    backHiddenDisabled() {
      return this.currentStep === this.minStep ||
        this.currentStep === this.maxStep ||
        (this.isUserPoolExist !== null && this.stepNames.length < 5);
    },
  },
  methods: {
    navigatePreviousStep() {
      const newStep = this.currentStep - 1;
      if (newStep >= this.minStep) {
        this.$emit('clicked', newStep);
      }
    },
    navigateNextStep() {
      const newStep = this.currentStep + 1;
      if (newStep <= this.maxStep) {
        this.$emit('clicked', newStep);
      }
    },
    onClickStepButton(stepToGo) {
      if (this.visitedStepsCnt >= stepToGo && this.currentStep !== this.maxStep) {
        this.$emit('clicked', stepToGo);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.registration-stepper {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
